import React, { useState } from "react";
import OwButton from "../../../OwButton/OwButton";
import { FormattedNumber } from "react-intl";
import IChRobinsonQuoteSummaryItem from "../../../../../models/IChRobinsonQuoteSummaryItem";
import OwLabel from "../../../OwLabel/OwLabel";
import UIService from "../../../../../services/UIService";

type Props = {
    item: IChRobinsonQuoteSummaryItem;
    index: number;
    selectedIndex?: number;
    selectRatingRequstIndex: (index: number) => void;
    hideSelect: boolean;
};

export const ChRobinsonRatesModalListViewLine = (props: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const isLightMode = UIService.isMainViewLight();

    const openDetails = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={"ChRobinsonRatesModalListViewLine w-100"}>
            <div className={"d-flex w-100 p-2 align-items-center"}>
                <div className={"w-25 pointer"} onClick={openDetails}>
                    <i className={"fas fa-play fa-sm " + (isOpen ? "fa-rotate-90" : "")} /> {props.item.carrier?.carrierName}
                </div>
                <div className={"w-25 ms-2 me-2"}>
                    {props.hideSelect ? null : (
                        <OwButton
                            title={props.selectedIndex === props.index ? "selected" : "select"}
                            fn={() => {
                                props.selectRatingRequstIndex(props.index);
                            }}
                            className={props.selectedIndex === props.index ? "btn-warning" : ""}
                        />
                    )}
                </div>
                <div className={"w-25"}>{props.item.transportModeType}</div>
                <div className={"w-25 text-end"}>
                    <FormattedNumber
                        value={props.item.totalCharge}
                        style={"currency"}
                        currency={"USD"}
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                    />
                </div>
            </div>
            {isOpen ? (
                <table className={"table " + (isLightMode ? "" : "table-dark")}>
                    <tr>
                        <th>
                            <OwLabel title={"equipment_type"} postText={":"} className={"me-2"} />
                        </th>
                        <td>{props.item.transportModeType}</td>
                    </tr>
                    <tr>
                        <th>
                            <OwLabel title={"min_transit_days"} postText={":"} className={"me-2"} />
                        </th>
                        <td>{props.item.transit.minimumTransitDays}</td>
                    </tr>
                    <tr>
                        <th>
                            <OwLabel title={"origin_service"} postText={":"} className={"me-2"} />
                        </th>
                        <td>{props.item.transit.originService}</td>
                    </tr>
                    <tr>
                        <th>
                            <OwLabel title={"rate_breakdown"} className={"me-2"} />
                        </th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>
                            <OwLabel title={"freight_charge"} postText={":"} className={"me-2"} />
                        </th>
                        <td className={"text-end"}>
                            <FormattedNumber
                                value={props.item.totalFreightCharge}
                                style={"currency"}
                                currency={"USD"}
                                minimumFractionDigits={2}
                                maximumFractionDigits={2}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <OwLabel title={"additional_charges"} postText={":"} className={"me-2"} />
                        </th>
                        <td className={"text-end"}>
                            <FormattedNumber
                                value={props.item.totalAccessorialCharge}
                                style={"currency"}
                                currency={"USD"}
                                minimumFractionDigits={2}
                                maximumFractionDigits={2}
                            />
                        </td>
                    </tr>
                </table>
            ) : (
                ""
            )}
        </div>
    );
};
